import { render, staticRenderFns } from "./db_tools.vue?vue&type=template&id=2877f2da"
import script from "./db_tools.vue?vue&type=script&lang=js"
export * from "./db_tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports